<section class="confirmation auth-bg">
  <img class="img-top" src="/assets/auth/confirmation/1.svg" alt="image" />
  <div class="confirmation-container">
    <div class="confirmation-wrapper">
      <img
        class="img-logo"
        src="/assets/auth/workplace-hover.svg"
        alt="logo-image"
      />
      <div class="confirmation-title">
        <h2>{{ "auth.titleConfirmation" | translate }}</h2>
        <p>
          {{ "auth.signUp.descriptionConfirmation" | translate }}
        </p>
      </div>
      <form [formGroup]="form">
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="firstName"
            >{{ "forms.addAdmin.firstNameLabel" | translate
            }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="first_name"
              placeholder="{{
                'forms.addAdmin.firstNamePlaceholder' | translate
              }}"
              class="form-input"
              appFormInput
              id="firstName"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="lastName"
            >{{ "forms.addAdmin.lastNameLabel" | translate
            }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="last_name"
              placeholder="{{
                'forms.addAdmin.lastNamePlaceholder' | translate
              }}"
              class="form-input"
              appFormInput
              id="lastName"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="Email"
            >{{ "forms.addAdmin.emailLabel" | translate
            }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              formControlName="email"
              placeholder="{{ 'forms.addAdmin.emailPlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="email"
              [disabled]="true"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="phone"
            >{{ "auth.signUp.phone" | translate }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="phone"
              placeholder="{{ 'auth.signUp.phonePlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="phone"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="companyName"
            >{{ "auth.signUp.company" | translate
            }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="company_name"
              placeholder="{{ 'auth.signUp.namePlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="companyName"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="country">{{
            "auth.signUp.country" | translate
          }}</nz-form-label>
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="country"
              placeholder="{{ 'auth.signUp.countryPlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="country"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="city">{{
            "auth.signUp.city" | translate
          }}</nz-form-label>
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="city"
              placeholder="{{ 'auth.signUp.cityPlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="city"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="address"
            >"{{ "auth.signUp.address" | translate }}</nz-form-label
          >
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="street"
              placeholder="{{ 'auth.signUp.addressPlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="address"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="building">{{
            "auth.signUp.buildingNumber" | translate
          }}</nz-form-label>
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="building"
              placeholder="{{ 'auth.signUp.phonePlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="building"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="zip">{{
            "auth.signUp.zip" | translate
          }}</nz-form-label>
          <app-form-field>
            <input
              nz-input
              oninput="this.value ? this.value : this.value.trim()"
              formControlName="zip"
              placeholder="{{ 'auth.signUp.phonePlaceholder' | translate }}"
              class="form-input"
              appFormInput
              id="zip"
            />
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="password"
            >{{ "auth.password" | translate }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <nz-input-group
              class="form-input-group"
              [nzSuffix]="passwordSuffix"
              [nzStatus]="passwordError"
            >
              <input
                nz-input
                formControlName="password"
                placeholder="{{ 'auth.enterPassword' | translate }}"
                oninput="this.value=this.value.trim()"
                [type]="passwordVisible ? 'text' : 'password'"
                appFormInput
                id="password"
              />
            </nz-input-group>
          </app-form-field>
        </nz-form-item>
        <nz-form-item class="inline-field">
          <nz-form-label nzFor="confirmPassword"
            >{{ "auth.confirmPassword" | translate
            }}<span>*</span></nz-form-label
          >
          <app-form-field>
            <nz-input-group
              class="form-input-group"
              [nzSuffix]="confirmPasswordSuffix"
              [nzStatus]="confirmError"
            >
              <input
                nz-input
                [type]="confirmPasswordVisible ? 'text' : 'password'"
                oninput="this.value=this.value.trim()"
                formControlName="confirm_password"
                placeholder="{{ 'auth.enterPassword' | translate }}"
                appFormInput
                id="confirmPassword"
              />
            </nz-input-group>
          </app-form-field>
        </nz-form-item>
      </form>
      <button (click)="submit()" nz-button>
        {{ "auth.buttonCreate" | translate }}
      </button>
    </div>
  </div>
  <img class="img-bottom" src="/assets/auth/confirmation/2.svg" alt="image" />
  <app-spinner *ngIf="loading"></app-spinner>
</section>

<ng-template #passwordSuffix>
  <span nz-icon (click)="passwordVisible = !passwordVisible">
    <img
      [src]="
        passwordVisible ? '/assets/icons/open.svg' : '/assets/icons/hide.svg'
      "
      alt="show-password"
    />
  </span>
</ng-template>
<ng-template #confirmPasswordSuffix>
  <span nz-icon (click)="confirmPasswordVisible = !confirmPasswordVisible">
    <img
      [src]="
        confirmPasswordVisible
          ? '/assets/icons/open.svg'
          : '/assets/icons/hide.svg'
      "
      alt="show-password"
    />
  </span>
</ng-template>

<app-message></app-message>
